import React from "react";
import axios from 'axios';
import '../SmcLife/IndexLife.css';
import DidYouKnow from "../SmcLife/Images/Did-you-know.svg";
import ContactUs from "../SmcLife/Images/FAQ-contact.svg";
import Mobile from "../SmcLife/Images/mobile.svg";
import MaskedInput from "react-text-mask";
import { useState, useEffect } from "react";
const QuoteFooter = (props) => {
    const [MobileNo, setMobileNo] = useState(props.MobileNo);

    useEffect(() => {
        setMobileNo(props?.MobileNo)
    }, [props.MobileNo]);

    return (
        <>
            <div className="row quote_footer_main">
                {!props?.goToContact ?
                    (<div className="col-md-6 quote-footer-container">
                        <img className="quote-contact-us-img" src={ContactUs} alt="contact us" />
                        <div className="quote-footer-right-content">
                            <h4>Call us now if you are still confused!</h4>
                            <p>Have a talk with our expert</p>
                            <div className="quote-footer-mobile mt-3 mb-2" >
                                <MaskedInput
                                    className="input-text-footer-mobile"
                                    mask={[
                                        /[6-9]/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                        /\d/,
                                    ]}
                                    guide={false}
                                    required
                                    showMask={false}
                                    name="MobileNo"
                                    value={MobileNo}
                                    onChange={(e) => setMobileNo(e.target.value)}


                                />
                                <span className="errors-msg">{Error["MobileNo"]}</span>
                                <span className="floating-label floating_label_footer">Mobile Number</span>
                                <img src={Mobile} className="cellphone" alt="Mobile" />
                            </div>
                            <button
                                className="ContactBtnFooter"
                                onClick={() => props?.reqCallBack(MobileNo)}
                            >
                                <i className="fa fa-phone"></i>
                                Talk to an expert
                            </button>
                        </div>
                    </div>)
                    :
                    (<div className="col-md-6 quote-footer-container">
                        <div className="ionic-md-call">
                            <i className="fa fa-phone call-icon"></i>
                        </div>
                        <div className="quote-footer-right-content">
                            <h4>We have received your request. We will call you soon!</h4>
                            <p>Operational timings: 10 AM-6 PM<br />or<br />Call us (Toll Free) on 1800 2666 3666</p>

                        </div>
                    </div>)}
                <div className="col-md-6 quote-footer-container">
                    <img className="quote-right-container-img" src={DidYouKnow} alt="Did You Know" />
                    <div className="quote-footer-right-content">
                        <h4>Did you know?</h4>
                        <p>Under Section 80C, individuals can claim deductions from their total income for premiums paid towards term insurance. This deduction also covers critical illness riders and other add-ons.</p>
                    </div>
                </div>
            </div>
        </>
    )
}
export default QuoteFooter;